import { Icon, Text } from '@kanda-libs/ks-design-library';
import { ITEM_CLASS_NAMES, ITEM_PROPS } from './constants';

interface CheckListItemProps {
  isLoading?: boolean;
  icon?: string;
  label?: string;
}

const CheckListItem = ({ isLoading, icon, label }: CheckListItemProps) => {
  const innerItemProps = { isLoading };

  return (
    <div className={ITEM_CLASS_NAMES.container}>
      <Icon icon={icon} {...ITEM_PROPS.icon} {...innerItemProps} />
      <Text text={label} {...ITEM_PROPS.title} {...innerItemProps} />
    </div>
  );
};

CheckListItem.defaultProps = {
  icon: 'check',
  isLoading: false,
  label: undefined,
};

export default CheckListItem;
